module.exports = __webpack_public_path__ + "static/green_dragon-dea80e0374d28cca5c80a81952ebfa7b.jpg";